import type React from 'react';
import { useEffect, useState } from 'react';

import { ReachGoalStep } from './components/ReachGoalStep';
import { SetGoalStep } from './components/SetGoalStep';
import { DEFAULT_GOAL } from './components/SetGoalStep/constants';

const STEPS = {
	SetGoal: 'SET_GOAL',
	ReachGoal: 'REACH_GOAL',
} as const;
type Step = (typeof STEPS)[keyof typeof STEPS];

export const SharingGoalFlow: React.FC = () => {
	const [step, setStep] = useState<Step>(STEPS.SetGoal);
	const [goalValue, setGoalValue] = useState(DEFAULT_GOAL);

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, [step]);

	function handleNext(chosenGoal: number) {
		setGoalValue(chosenGoal);
		setStep(STEPS.ReachGoal);
	}

	return step === STEPS.SetGoal ? <SetGoalStep onNext={handleNext} /> : <ReachGoalStep goalValue={goalValue} />;
};
